import { classNames } from "src/helpers/classNames";

export default function MetabaseEmbedPlatform({ content }) {
  return (
    <>
      <div className={classNames("relative h-full w-full")}>
        {content?.embedUrl && (
          <div className="mx-auto h-full w-full  overflow-auto">
            <iframe
              id="iframe"
              title="Domo Embed"
              src={content?.embedUrl}
              width="100%"
              height="100%"></iframe>
          </div>
        )}
      </div>
    </>
  );
}
